// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBR1QdVS9v3wjubtbsKk-UsyosegD0KPkM",
    authDomain: "nyssahealth-8a17d.firebaseapp.com",
    projectId: "nyssahealth-8a17d",
    storageBucket: "nyssahealth-8a17d.firebasestorage.app",
    messagingSenderId: "172631061300",
    appId: "1:172631061300:web:19415c2fc9b6c00b07eb61",
    measurementId: "G-Q0SW4QBNTR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage };